import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROUTE_PARAM } from './messenger.constants';
import { ChatListPageComponent } from './chat-list-page/chat-list-page.component';
import { ChatPageComponent } from './chat-page/chat-page.component';

const routes: Routes = [
  {
    path: '',
    component: ChatListPageComponent
  },
  {
    path: `:${ROUTE_PARAM.CONVERSATION_ID}`,
    component: ChatPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MessengerRoutingModule { }
